var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-item',{attrs:{"link":{name: _vm.$t('Корпоративная политика'),  path: `/corpPolicy`,  icon: 'vip_icon icon_policy'}}})
}
var staticRenderFns = []

export { render, staticRenderFns }